import Icon from 'Components/Atoms/Icon/Icon';
import { useTranslation } from 'react-i18next';
import Skeleton from 'Components/Atoms/Skeleton/Skeleton';
import useWorkspaceSelected from 'Hooks/useWorkspaceSelected';
import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ChangeWorkspaceDialog from './ChangeWorkspaceDialog';

export default function ChangeWorkspaceButton(props) {
    const { className } = props;
    const { t } = useTranslation('common');
    const { workspace, isLoading } = useWorkspaceSelected();

    const workspaceName = workspace?.name || '';
    const [showChangeWorkspaceModal, setShowChangeWorkspaceModal] = useState(false);

    return (
        <>
            <ChangeWorkspaceDialog open={showChangeWorkspaceModal} onClose={() => setShowChangeWorkspaceModal(false)} />

            <button
                type="button"
                className={cn('group flex items-center gap-3 text-left text-dark-blue p-4', className)}
                data-testid="header.workspace-switcher"
                onClick={() => setShowChangeWorkspaceModal(true)}
            >
                <div className="grow">
                    <div className="uppercase text-2xs text-gray-500 tracking-wider">{t('workspace')}</div>
                    {isLoading ? (
                        <Skeleton variant="text" width={90} />
                    ) : (
                        <div className="font-semibold text-sm">{workspaceName}</div>
                    )}
                </div>
                <div className="shrink-0 text-dark-blue/50 group-hover:text-dark-blue transition-colors">
                    <Icon name="switch" size={24} color="currentColor" />
                </div>
            </button>
        </>
    );
}

ChangeWorkspaceButton.propTypes = {
    className: PropTypes.string,
};
